module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pinch-in-card"
  }, [_c('div', {
    staticClass: "modal-inner flexcenter"
  }, [_c('div', {
    staticClass: "pinch-type card-voice"
  }, [_c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.clickClose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pinch-inInner"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pinchInParams.pinchInImagePath
    }
  })])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ba8f62d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-5ba8f62d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/PinchInImg.vue
// module id = 631
// module chunks = 1